import { Link } from 'react-router-dom';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';

export default function Breadcrumbs({ items = [], className }) {
  if (!items.length) return null;

  return (
    <nav aria-label="Breadcrumb" className={clsx('flex items-center gap-1 text-sm min-w-0', className)}>
      <Link
        to="/dashboard"
        className="shrink-0 p-1 rounded-lg text-surface-400 hover:text-brand-600 hover:bg-brand-500/5 transition-colors"
        aria-label="Dashboard"
      >
        <HomeIcon className="h-4 w-4" />
      </Link>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-1 min-w-0">
            <ChevronRightIcon className="h-3.5 w-3.5 text-surface-300 shrink-0" />
            {item.href && !isLast ? (
              <Link
                to={item.href}
                className="text-surface-500 hover:text-brand-600 truncate transition-colors"
              >
                {item.label}
              </Link>
            ) : (
              <span className={clsx('truncate', isLast ? 'font-medium text-dark-900' : 'text-surface-500')}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}
